export const LOGIN = "/auth/login"
export const ADD_USER = "/auth/register"
export const UPDATE_USER_STATUS = "/auth/user/status"
export const UPDATE_USER_PASSWORD = "/auth/user/password"